import Slider from 'components/3catinfo/Slider';
import __isEmpty from 'lodash/isEmpty';
import Imatge from 'components/3catinfo/Imatge/Imatge';
import styles from './tiravegueries.module.scss';
import Enllac from 'components/3catinfo/Enllac/Enllac';

const Vegueria = (props) => {
    const { item, index, infoBlocRedl } = props;
    const { desc, routePath, slug, image } = item;
    const route = { slug, type: routePath };

    const indexMarcatge = index || 1;

    let marcatgeAudienciesClick = '';
    if (infoBlocRedl) {
        const descripcio = infoBlocRedl?.descripcio ? infoBlocRedl.descripcio.replace(':', '.') : '';
        marcatgeAudienciesClick = `Tira:${indexMarcatge}:${descripcio}`;
    }

    return (
        <div className={styles.zona}>
            <Enllac route={route} marcatgeAudienciesClick={marcatgeAudienciesClick}>
                <div className={styles.cos} data-testid='vegueria-item'>
                    <div className={styles.imatgeWrapper}>
                        {image && <Imatge src={image} layout='fill' objectFit='contain' mostrarRecursTitol={false} />}
                    </div>
                    <div className={styles.zonaDesc}>{desc}</div>
                </div>
            </Enllac>
        </div>
    );
};

const TiraVegueries = (props) => {
    const { items, titol, infoBlocRedl } = props;

    let { numColumnsRow } = props;
    numColumnsRow = __isEmpty(numColumnsRow) ? 12 : Math.round(numColumnsRow / 5);

    return (
        <>
            {items && (
                <Slider format='tira_vegueries' estil='tiraVegueries' estilModul='vegueries' fletxes='mig' titol={titol} tag='h3'>
                    {items.map((item, i) => (
                        <Vegueria key={`tria-vegueria-${item.slug}`} item={item} index={i + 1} infoBlocRedl={infoBlocRedl} />
                    ))}
                </Slider>
            )}
        </>
    );
};

export default TiraVegueries;
